import NotificationItem from './NotificationItem';

export default {
    components: {
        NotificationItem,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        hide () {
            this.$emit('remove', this.data.id);
        },
    },
}
